import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
interface MetaConfig {
  title?: string;
  description?: string;
  image?:string;
  slug?:string;
}
@Injectable({
  providedIn: 'root'
})
export class SeoService {
 namePhoto_ext: any;
 namePhoto_int: any;
 showMenuMulti = false;
  constructor(private http: HttpClient,private meta: Meta) { }

  generateTags(config:MetaConfig) {
    // default values
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:site_name', content: 'AngularFirebase' });
    this.meta.updateTag({ property: 'og:title', content: config.title });
    this.meta.updateTag({ property: 'og:description', content: config.description });
    this.meta.updateTag({ property: 'og:image', content: config.image });
    this.meta.updateTag({ property: 'og:url', content: `https://instafire-app.firebaseapp.com/${config.slug}` });


}

public generatePdf(){


}

public sharePost(fd,view){

  return  this.http.post<any>(`/upload.php`, fd).subscribe(data => {
    switch(view){
      case '1':
                this.namePhoto_int = data;
                break;
      default:
              this.namePhoto_ext = data;

    }
     this.namePhoto_ext = data;
    let config = {
      title: 'Simulateur',
      description: 'Simulateur de portes',
      image: '/simulation/photos/'+data.fileName+".jpg",
      slug: 'simulateur'}
   this.generateTags(config);


    });

 }
 public getImageName(view){

  switch(view){
    case '1':
             return  this.namePhoto_int ;
              break;
    default:
           return this.namePhoto_ext ;

  }


 }

getShowMultiproduct(show)
{
  this.showMenuMulti = show
}
getetShowMultiproduct()
{
  return this.showMenuMulti;
}


}
